module.exports = {"630225100":"积石镇","630225101":"白庄镇","630225102":"街子镇","630225200":"道帏藏族乡","630225201":"清水乡","630225202":"岗察藏族乡","630225203":"查汗都斯乡","630225204":"文都藏族乡","630225205":"尕楞藏族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/630225.json
// module id = 3131
// module chunks = 0